import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { FeasibilityRuleSimple } from 'src/app/models/FeasibilityRuleSimple';
import { FEASIBILITY_KEYS } from 'src/app/shared/constants/common.constants';
import { UtilsService } from 'src/app/utils/utils.service';
import { IrpfTableComponent } from '../../../../shared/components/irpf-table/irpf-table.component';
import { IrpfTableService } from '../../../../shared/components/irpf-table/irpf-table.service';
import { FreelancerRequestDetailService } from '../freelancer-request-detail.service';
import { FeasibilityRulesTableComponent } from './feasibility-rules-table/feasibility-rules-table.component';
import { FreelancerRequestDetailDocumentsService } from './freelancer-request-detail-documents.service';

@Component({
    selector: 'app-freelancer-request-detail-documents',
    templateUrl: './freelancer-request-detail-documents.component.html',
    standalone: true,
    imports: [
        NgIf,
        Button,
        TooltipModule,
        AccordionModule,
        NgFor,
        DecimalPipe,
        TranslateModule,
        FeasibilityRulesTableComponent,
        IrpfTableComponent
    ]
})
export class RequestDetailDocumentsComponent {

    readonly feasibilityKeys: string[] = FEASIBILITY_KEYS;

    constructor(
		readonly freelancerRequestDetailDocumentsService: FreelancerRequestDetailDocumentsService,
		readonly freelancerRequestDetailService: FreelancerRequestDetailService,
		private readonly router: Router,
		readonly utilsService: UtilsService,
		private readonly translateService: TranslateService,
        readonly irpfTableService: IrpfTableService
    ) { }

    newWindowWithJSONViewer(obj: object): void {
	    localStorage.setItem('jsonViewerObject', JSON.stringify(obj));

	    // open the JSON viewer in a new tab.
	    const urlTree = this.router.createUrlTree(['json']);
	    const absoluteUrl = `${window.location.origin}${this.router.serializeUrl(urlTree)}`;

	    // open the new tab with the calculated URL
	    window.open(absoluteUrl, '_blank');
    }

    showOpenPDFButton(name: string): boolean {
        const url = this.freelancerRequestDetailService.request.documents[name];
        return url && url.trim() !== '';
    }

    openPDF(name: string): void {
	    const url = this.freelancerRequestDetailService.request.documents[name];
	    if (url) {
	        window.open(url, '_blank');
	    }
    }

    downloadPDF(name: string): void {
	    this.freelancerRequestDetailService.saveDocument(this.freelancerRequestDetailService.request.documents[name], name).catch(error => { console.error(error); });
    }

    openJSON(name: string): void {
	    this.newWindowWithJSONViewer(this.freelancerRequestDetailService.request.data[name]);
    }

    downloadJSON(name: string): void {
	    this.freelancerRequestDetailService.saveJSON(this.freelancerRequestDetailService.request.data[name], name);
    }

    translateFeasibilityKey(key: string): string {
	    return this.translateService.instant(`FEASIBILITY_KEYS.${key}`);
    }

    translateEnrichmentKey(key: string): string {
        return this.translateService.instant(`FREELANCERS_ENRICHMENT_KEYS.${key}`);
    }

    isNumber(value: any): boolean {
	    return typeof value === 'number';
    }

    translateIfBoolean(value: any): string {
	    if (typeof value === 'boolean') {
	        return this.utilsService.translateBoolean(value);
	    } else {
	        return value;
	    }
    }

    isFeasibilityAvailable(): boolean {
	    if (this.freelancerRequestDetailService.feasibilityData.isCreditOperationMade) {
	        return false;
	    }

	    return this.freelancerRequestDetailService.request.personQuery.status === "Success";
    }

    showFesibilityRules(): boolean {
        if (!this.freelancerRequestDetailService.feasibilityEnrichmentData) return false;
        const rules = this.freelancerRequestDetailService.feasibilityEnrichmentData['rules'];
        return rules && rules.length > 0;
    }

    getFeasibilityRules(): FeasibilityRuleSimple[] {
        if (!this.freelancerRequestDetailService.feasibilityEnrichmentData) return [];
        const rules = this.freelancerRequestDetailService.feasibilityEnrichmentData['rules'];
        return rules ? rules : [];
    }
}

// pagination idea
//GET https://api.opendata.com/requests?requestId=123908asdncas&pagination=90&from=100&to=180
//GET https://api.opendata.com/requests?requestId=123908asdncas&pagination=90&from=180&to=340
